var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSideJob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3771 18H4.62287C2.07401 18 0 16.002 0 13.5456V8.63648C0 6.18013 2.07401 4.18213 4.62287 4.18213H13.3771C15.926 4.18213 18 6.18013 18 8.63648V13.5456C18 16.002 15.926 18 13.3771 18Z",
    fill: "#0083FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02322 1.27124C6.73676 1.27124 4.88322 3.12099 4.88322 5.40277V8.05119C4.88322 8.40223 4.59806 8.68681 4.2463 8.68681C3.89454 8.68681 3.60938 8.40223 3.60938 8.05119V5.40277C3.60938 2.4189 6.03324 0 9.02322 0C12.0132 0 14.4371 2.4189 14.4371 5.40277V8.05119C14.4371 8.40223 14.1519 8.68681 13.8001 8.68681C13.4484 8.68681 13.1632 8.40223 13.1632 8.05119V5.40277C13.1632 3.12099 11.3097 1.27124 9.02322 1.27124Z",
    fill: "#0083FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1116 15.0558C19.1116 17.2957 17.2957 19.1116 15.0558 19.1116C12.8158 19.1116 11 17.2957 11 15.0558C11 12.8158 12.8158 11 15.0558 11C17.2957 11 19.1116 12.8158 19.1116 15.0558Z",
    fill: "#0083FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.5887C13.5 16.8479 13.6981 17 13.9698 17H16.1208C16.3302 17 16.5 16.8366 16.5 16.6282C16.5 16.4197 16.3302 16.2507 16.1208 16.2507H14.7396L15.3849 15.7549C16.0868 15.2141 16.4264 14.8873 16.4264 14.2282V14.2169C16.4264 13.4789 15.883 13 15.0623 13C14.4623 13 14.0887 13.2141 13.7717 13.5803C13.7094 13.6535 13.6698 13.7549 13.6698 13.8507C13.6698 14.0704 13.8453 14.2451 14.066 14.2451C14.2019 14.2451 14.3038 14.1831 14.3604 14.1211C14.5811 13.8845 14.7566 13.7775 15.0057 13.7775C15.317 13.7775 15.5377 13.9577 15.5377 14.2901C15.5377 14.6169 15.3453 14.8366 14.8528 15.2366L13.7264 16.1549C13.5792 16.2732 13.5 16.4197 13.5 16.5887Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 15C20 17.7614 17.7614 20 15 20C12.2386 20 10 17.7614 10 15C10 12.2386 12.2386 10 15 10C17.7614 10 20 12.2386 20 15ZM15 19.0558C17.24 19.0558 19.0558 17.24 19.0558 15C19.0558 12.76 17.24 10.9442 15 10.9442C12.76 10.9442 10.9442 12.76 10.9442 15C10.9442 17.24 12.76 19.0558 15 19.0558Z",
    fill: "#EEF6FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideJob);
export default __webpack_public_path__ + "static/media/sideJob.677450ea.svg";
export { ForwardRef as ReactComponent };